import React from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Formik, Field, Form } from 'formik';
import { IonLoading, IonImg, IonButton, IonList, IonText } from '@ionic/react';
import { InputField } from 'components/form';
import AppActions from 'redux/AppRedux';
import AuthActions from 'redux/AuthRedux';
import api_v2 from 'services/api_v2';
import { encryptPhone } from 'utils/phone';
import schema from './schema';

const INITIAL_VALUES = {
  phone: '',
};

function ForgotPasswordForm() {
  const dispatch = useDispatch();
  const history = useHistory();
  const handleSubmit = async (values, actions) => {
    const data = { phone: values.phone, type: 'reset' }; /* this can be either phone or username, but we always send it as phone */

    try {
      await api_v2().requestSmsCode(data);

      dispatch(
        AppActions.setToast(
          `Password reset code has been sent to ${encryptPhone(data.phone)}`,
          'success'
        )
      );

      dispatch(AuthActions.setForgot(data.phone));

      history.push('/auth/reset-password');
    } catch (e) {
      dispatch(
        AppActions.setToast(
          e.message || 'Failed sending password reset code',
          'danger'
        )
      );
    }

    actions.setSubmitting(false);
  };

  return (
    <Formik
      initialValues={{ ...INITIAL_VALUES }}
      onSubmit={handleSubmit}
      validationSchema={schema}
    >
      {({ isSubmitting }) => {
        return (
          <Form>
            <IonLoading isOpen={isSubmitting} message="Loading..." />
            <IonList>
              <div className="auth-logo">
                <IonImg src="/assets/vemospay-logo.png" />
              </div>
              <Field
                component={InputField}
                name="phone"
                type="tel"
                label="Phone number *"
              />
              <IonText color="medium" className="mb-2x">
                <small>(Use format 6123334444)</small>
              </IonText>
              <div className="mt-3x mb-5x">
                <IonButton
                  color="secondary"
                  expand="block"
                  fill="solid"
                  type="submit"
                  disabled={isSubmitting}
                >
                  Send Reset Code
                </IonButton>
              </div>
              <Link to="/auth/login">
                <IonText color="medium">
                  <small>Back to Login</small>
                </IonText>
              </Link>
            </IonList>
          </Form>
        );
      }}
    </Formik>
  );
}

export default ForgotPasswordForm;
